import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a67b6e4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "add-account"
};
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessageBox, ElMessage } from 'element-plus';
import tableComponent from './components/Table';
import { deleteDongleUserModuleById, findDongleUserModule } from '@/api/dongle';
import { moduleDataSchemas } from './config';
// import DongleUser from './components/DongleUser'
import DongleUserAuth from './components/DongleUserAuth';
export default {
  __name: 'module',
  setup(__props) {
    const tableData = ref([]);
    const route = useRoute();
    const userId = ref(route.params.id);
    const dangleUserName = route.query.dangUser;

    // loading效果
    const loading = ref(false);
    const getData = async () => {
      loading.value = true;
      const res = await findDongleUserModule({
        userId: userId.value
      });
      tableData.value = res;
      loading.value = false;
    };
    const handleDongleDelete = async raw => {
      try {
        await ElMessageBox.confirm('确认删除吗', '温馨提示', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        });

        // 如果该租户的子诊所数量为0的话
        await deleteDongleUserModuleById(raw.id);
        getData();
        ElMessage({
          message: '删除成功',
          type: 'success'
        });
      } catch (error) {}
    };
    const router = useRouter();
    const handleApproval = row => {
      router.push(`/application/approval/${row.id}`);
    };
    onMounted(() => {
      getData();
    });

    // const handleChangeStatus = async (val) => {
    //   let moduleStatus = val.moduleStatus
    //   const state = val.state

    //   // console.log('🚀 ~ handleChangeStatus ~ state:', state)
    //   // console.log('🚀 ~ handleChangeStatus ~ moduleStatus:', moduleStatus)
    //   // eslint-disable-next-line
    //   moduleStatus = state ? 1 : 0
    //   delete val.state
    //   await updateDongleUserModule({
    //     ...val,
    //     moduleStatus
    //   })

    //   await getData()

    //   ElMessage.success('切换成功')
    // }

    const authVisible = ref(false);
    const handleAddRow = () => {
      authVisible.value = true;
    };
    const currentDongleUser = ref(null);
    const handleDongleUpdate = val => {
      currentDongleUser.value = JSON.parse(JSON.stringify(val));
      authVisible.value = true;
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        class: "title-card",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("h3", null, "当前加密狗用户编号： " + _toDisplayString(_unref(dangleUserName)), 1), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAddRow
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(tableComponent), {
          tableData: tableData.value,
          loading: loading.value,
          schemas: _unref(moduleDataSchemas),
          onUpdate: handleDongleUpdate,
          onDel: handleDongleDelete,
          onApproval: handleApproval
        }, null, 8, ["tableData", "loading", "schemas"])]),
        _: 1
      }), _createVNode(_unref(DongleUserAuth), {
        modelValue: authVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => authVisible.value = $event),
        model: currentDongleUser.value,
        onRefreshData: getData,
        onClearModel: _cache[1] || (_cache[1] = $event => currentDongleUser.value = null)
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};